import React from "react";
import LazyLoadImage from "@/components/atoms/LazyLoadImage";

import tracking from "@/utils/tracking";
import {
	IMAGE,
	HEADER_COPY,
	BODY_COPY,
	CTA_COPY,
	CTA_LINK
} from "@/utils/content-keys";
import "./details.scss";

export default class Details extends React.Component {

	render() {
		const { content } = this.props;

		return (
			<div class="container-fluid">

				<div className="details row flex-column-reverse flex-sm-row">
					<div className="details__col-1 col-12 col-sm-6">
						<LazyLoadImage
							src={content[IMAGE][0].imgURL}
							srcset={`${content[IMAGE][1].imgURL} 750w, ${
								content[IMAGE][0].imgURL
								} 1984w`}
							lazyCallback={() => { }} className="details__image"
							alt={content[IMAGE][0].alternateText}
						/>
					</div>

					<div className="details__col-2 col-12 col-sm-6 align-self-start">
						<h3 className="details__headline">{content[HEADER_COPY].value}</h3>
						<p
							className="details__copy"
							dangerouslySetInnerHTML={{
								__html: content[BODY_COPY].value.replace(
									/\*\*([^*]+)\*\*/g,
									'<span class="details__copy--lg">$1</span>'
								)
							}}
						/>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href={content[CTA_LINK].value}
							className="cta cta--invert cta--details"
							onClick={() =>
								tracking.event("customEvent", {
									eventCategory: "Google Maps",
									eventAction: "click",
									eventLabel: "Homepage"
								})
							}
						>
							{content[CTA_COPY].value}
						</a>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/home/Details/index.js